import { useDispatch, useSelector } from 'react-redux';
import { getOtpAction, verifyOtpAction } from '../../../travellersDetails/store/actions/UserActions';
import { toggleChoice } from '../../../travellersDetails/store/actions/NewAccountActions';
import {useState} from "react";

export default function useVerificationSuccessfulContainer() {
  const dispatch = useDispatch();
  const {
    newAccount: {userName, email, mobileNumber},
    user: {getOtpResponse, verifyOtpResponse}
  } = useSelector((state: any) => state);

  const [verificationCompleted, setVerification] = useState(false);
  const completeVerification = () => setVerification(true);

  const _toggleChoice = (key) => {
    dispatch(toggleChoice(key));
  };

  const _getOtpAction = (userId, otpType) => {
    dispatch(getOtpAction(userId, otpType))
  };
  const _verifyOtpAction = (userId, otpType, queryParams) => {
    dispatch(verifyOtpAction(userId, otpType, queryParams));
  }
  return {
    state: {
      userName, email, mobileNumber,
      getOtpResponse, verifyOtpResponse, verificationCompleted,
    },
    action: {
      _toggleChoice,
      _getOtpAction,
      _verifyOtpAction,
      completeVerification
    },
  };
};
